import { EmptyEdgePropsSchema } from '../../graph-schemas/edges/common';
import type { EdgeDefinition } from './base-crm';

export const PMN_EDGES: Record<string, EdgeDefinition> = {
  PROPERTY_OF: {
    type: 'PROPERTY_OF',
    schema: EmptyEdgePropsSchema,
    displayName: 'Property Of',
    reverseDisplayName: 'Has Property',
    sourceTypes: ['Property'],
    targetTypes: ['*'],
    props: [],
  },
  METRIC_OF: {
    type: 'METRIC_OF',
    schema: EmptyEdgePropsSchema,
    displayName: 'Metric Of',
    reverseDisplayName: 'Has Metric',
    sourceTypes: ['Metric'],
    targetTypes: ['*'],
    props: [],
  },
  NARRATIVE_OF: {
    type: 'NARRATIVE_OF',
    schema: EmptyEdgePropsSchema,
    displayName: 'Narrative Of',
    reverseDisplayName: 'Has Narrative',
    sourceTypes: ['Narrative'],
    targetTypes: ['*'],
    props: [],
  },
};
